import { render } from "./Kozhencherry.vue?vue&type=template&id=12e350a8"
import script from "./Kozhencherry.vue?vue&type=script&lang=ts"
export * from "./Kozhencherry.vue?vue&type=script&lang=ts"
script.render = render

export default script